import { Directive, HostBinding, HostListener, Input } from '@angular/core';

export interface HighlightToggleConfig {
    highlightedClass: string;
    unhighlightedClass: string | undefined;
}

@Directive({
    selector: '[bsHighlightToggle]',
    standalone: false,
})
export class HighlightToggleDirective {
    private isHighlighted: boolean;

    @HostBinding('class')
    get class(): string {
        return this.isHighlighted ? this.bsHighlightToggle.highlightedClass : (this.bsHighlightToggle.unhighlightedClass ?? '');
    }

    @HostListener('document:click') documentClick() {
        this.isHighlighted = false;
    }

    @HostListener('click', ['$event']) onClick(_: MouseEvent) {
        this.isHighlighted = true;
    }

    @Input() bsHighlightToggle: HighlightToggleConfig;

    constructor() {}
}
